import Course from './course/model';
import StudyPlan from './result';
import { Map, List } from 'immutable';

import {
  FETCH_STUDY_PLAN_COURSES_SUCCESS,
  FETCH_STUDY_PLAN_SUCCESS,
} from './actions';

export default function StudyPlanReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_STUDY_PLAN_COURSES_SUCCESS:
      return onFetchCourseSuccess(state, action);
    case FETCH_STUDY_PLAN_SUCCESS:
      return onFetchStudyPlanSuccess(state, action);
    default:
      return state;
  }
}

function onFetchCourseSuccess(state, action) {
  const { idpId, payload } = action;
  if (payload) {
    let studyPlan = state.get(idpId) || new Map();
    const coreCourses = new List(payload.coreCourses.map((raw) => new Course(raw)));
    const nonCoreCourses = new List(payload.nonCoreCourses.map((raw) => new Course(raw)));
    studyPlan = studyPlan.set('coreCourses', coreCourses);
    studyPlan = studyPlan.set('nonCoreCourses', nonCoreCourses);
    return state.set(action.idpId, studyPlan);
  }
  return state;
}

function onFetchStudyPlanSuccess(state, action) {
  const { idpId, payload } = action;
  if (Array.isArray(payload)) {
    let studyPlan = state.get(idpId) || new Map();
    const result = new List(payload.map((raw) => StudyPlan.create(raw)));
    studyPlan = studyPlan.set('result', result);
    return state.set(idpId, studyPlan);
  }
  return state;
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/reducer.js